import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { KuposInput } from '../common';
import ApiUrls from '../../services/apiUrls';
import CommonService from '../../services/commonService';
import { withTranslation, Trans } from 'react-i18next';
import i18next from 'i18next';

export class DefaultPage extends Component {
  static propTypes = {
    siteMap: PropTypes.object.isRequired,
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedOption: '',
      filtered: [{ label: '' }],
    };
    this.getSiteMap();
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  getSiteMap = () => {
    this.props.actions.getSiteMap({ url: ApiUrls.siteMap() });
  };

  // http://stage.kupas.cl/en/bus-tickets/kenny-bus

  componentDidUpdate() {
    if (!this.state.destination_locations && this.props.siteMap.mySiteMap) {
      this.setState({
        // terminal_locations: this.props.siteMap.mySiteMap.seo_term_details.slice(0, 100),
        // company_locations: this.props.siteMap.mySiteMap.seo_op_details.slice(0, 100),
        // destination_locations: this.props.siteMap.mySiteMap.seo_dest_details.slice(0, 100),
        // city_pair_locations: this.props.siteMap.mySiteMap.seo_city_pair_details.slice(0, 100),
        terminal_locations: this.props.siteMap.mySiteMap.seo_term_details,
        company_locations: this.props.siteMap.mySiteMap.seo_op_details,
        destination_locations: this.props.siteMap.mySiteMap.seo_dest_details,
        city_pair_locations: this.props.siteMap.mySiteMap.seo_city_pair_details,
      });
    }
  }

  onTerminalInputChange = input => {
    let filteredTerminals = this.props.siteMap.mySiteMap
      ? CommonService.copyObject(this.props.siteMap.mySiteMap.seo_term_details)
      : // ? CommonService.copyObject(this.props.siteMap.mySiteMap.seo_term_details.slice(0, 100))
        [];
    filteredTerminals = filteredTerminals.filter(val => {
      return (
        val[0]
          .split(',')[0]
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    });
    this.setState({ terminal_locations: filteredTerminals });
  };

  onCompanyInputChange = input => {
    let filteredTerminals = CommonService.copyObject(
      this.props.siteMap.mySiteMap.seo_op_details,
      // this.props.siteMap.mySiteMap.seo_op_details.slice(0, 100),
    );
    filteredTerminals = filteredTerminals.filter(val => {
      return (
        val[0]
          .split(',')[0]
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    });
    this.setState({ company_locations: filteredTerminals });
  };

  onDestinationInputChange = input => {
    let filteredTerminals = CommonService.copyObject(
      this.props.siteMap.mySiteMap.seo_dest_details,
      // this.props.siteMap.mySiteMap.seo_dest_details.slice(0, 100),
    );
    filteredTerminals = filteredTerminals.filter(val => {
      return (
        val[0]
          .split(',')[0]
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    });
    this.setState({ destination_locations: filteredTerminals });
  };

  onCityInputChange = input => {
    let filteredTerminals = CommonService.copyObject(
      this.props.siteMap.mySiteMap.seo_city_pair_details,
      // this.props.siteMap.mySiteMap.seo_city_pair_details.slice(0, 100),
    );
    filteredTerminals = filteredTerminals.filter(val => {
      return (
        val[0]
          .split(',')[0]
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    });
    this.setState({ city_pair_locations: filteredTerminals });
  };

  getList(val, key) {
    // console.log('Some data --------', val);
    let empty = false;
    let label1, link1, link2;
    val.map((item, index) => {
      if (item == '') {
        empty = true;
      }
      if (!empty) {
        switch (index) {
          case 0:
            label1 = item;
            break;
          case 1:
            link1 = item;
            break;
          case 3:
            link2 = item;
            break;
        }
      }
    });
    return label1 ? (
      <li className="list-item font10" key={key}>
        <a href={`https://kupos.cl/${i18next.language === 'es' ? val[2] : val[1]}`}>{label1}</a>
      </li>
    ) : null;
  }

  getPairedList(val, key) {
    // console.log('Item is ----------', val);
    let label1, label2, link1, link2;
    val.map((item, index) => {
      switch (index) {
        case 0:
          label1 = item;
          break;
        case 1:
          label2 = item;
          break;
        case 2:
          link1 = item;
          break;
        case 3:
          link2 = item;
          break;
      }
    });

    return (
      <li className="list-item font10" key={key}>
        <a href={`https://kupos.cl/${i18next.language === 'es' ? val[3] : val[2]}`}>
          {label1} to {label2}
        </a>
      </li>
    );
  }

  render() {
    const { t, history } = this.props;
    // console.log('All data in sitemap-----------------', this.state.company_locations);
    console.log('All site map data ----------', this.props.siteMap.mySiteMap);

    return (
      <div className="home-site-map">
        <div className="content-container">
          <div className="page-title font20">{t('HOME.SITEMAP')}</div>

          <div className="sitemam-grid-section">
            <div className="home-selection-input-box font13">
              <div className="primary-text upper-case-text">{t('HOME.TERMINALS')}</div>

              <KuposInput
                onChange={this.onTerminalInputChange}
                placeholder={t('HOME.SEARCH_TERMINAL')}
                icon="/static/images/icons/home/icon_search_primary.png"
                className={'kupos-sitemap-input'}
              />

              {this.state.terminal_locations ? (
                <div className="terminal-list">
                  {this.state.terminal_locations.map((val, key) => this.getList(val, key))}
                </div>
              ) : null}
            </div>

            <div className="home-selection-input-box font13">
              <div className="primary-text upper-case-text">{t('HOME.COMPANY_SITEMAP')}</div>

              <KuposInput
                onChange={this.onCompanyInputChange}
                placeholder={t('HOME.SEARCH_COMAPNY')}
                icon="/static/images/icons/home/icon_search_primary.png"
                className={'kupos-sitemap-input'}
              />

              {this.state.company_locations ? (
                <div className="terminal-list">
                  {this.state.company_locations.map((val, key) => this.getList(val, key))}
                </div>
              ) : null}
            </div>

            <div className="home-selection-input-box font13">
              <div className="primary-text upper-case-text">{t('HOME.DESTINATIONS')}</div>

              <KuposInput
                onChange={this.onDestinationInputChange}
                placeholder={t('HOME.SEARCH_DESTINATION')}
                icon="/static/images/icons/home/icon_search_primary.png"
                className={'kupos-sitemap-input'}
              />

              {this.state.destination_locations ? (
                <div className="terminal-list">
                  {this.state.destination_locations.map((val, key) => this.getList(val, key))}
                </div>
              ) : null}
            </div>

            <div className="home-selection-input-box font13">
              <div className="primary-text upper-case-text">{t('HOME.FREQUENT_ROUTES_UNIT')}</div>
              <KuposInput
                onChange={this.onCityInputChange}
                placeholder={t('HOME.SEARCH_FREQUENT_ROUTES')}
                icon="/static/images/icons/home/icon_search_primary.png"
                className={'kupos-sitemap-input'}
              />

              {this.state.city_pair_locations ? (
                <div className="terminal-list">
                  {this.state.city_pair_locations.map((val, key) => this.getPairedList(val, key))}
                </div>
              ) : null}
            </div>
          </div>

          <div className="text-center font13 primary-text upper-case-text sitemap-our-pages-title">
            {t('HOME.OUR_PAGES')}
          </div>
          <div className="kupos-border sitemap-our-pages">
            {/* <div className="text-center font16 primary-text upper-case-text">
              {t('HOME.OUR_PAGES')}
            </div> */}

            <div className="sitemap-pages-grid-section font11">
              <div className="font10">
                <div
                  className="underline"
                  onClick={() => history.push(`/${i18next.language}/pages/about`)}
                >
                  {t('HOME.ABOUT_KUPOS')}
                </div>
                <div className="underline" onClick={() => history.push(`#`)}>
                  {t('HOME.OUR_SERVICE')}
                </div>
                <div
                  className="underline"
                  onClick={() => history.push(`/${i18next.language}/pages/our-investors`)}
                >
                  {t('HOME.OUR_PARTNERS')}
                </div>
                <div
                  className="underline"
                  onClick={() => history.push(`/${i18next.language}/pages/travel-agency`)}
                >
                  {t('HOME.WORK_WITH_US')}
                </div>
              </div>

              <div className="font10">
                <div
                  className="underline"
                  onClick={() => history.push(`/${i18next.language}/pages/press`)}
                >
                  {t('HOME.PRESS')}
                </div>
                <div
                  className="underline"
                  onClick={() => history.push(`/${i18next.language}/pages/contact`)}
                >
                  {t('HOME.CONTACT_US')}{' '}
                </div>
                <div className="underline">
                  <a href="https://kupos.zendesk.com/hc/es" target="_blank">
                    {t('HOME.FAQ')}
                  </a>
                </div>
                <div
                  className="underline"
                  onClick={() => history.push(`/${i18next.language}/pages/tnc`)}
                >
                  {t('HOME.TNC')}{' '}
                </div>
              </div>

              <div className="font10">
                <div
                  className="underline"
                  onClick={() => history.push(`/${i18next.language}/pages/privacy-policy`)}
                >
                  {t('HOME.PRIVACY_POLICY')}{' '}
                </div>
                {/* <div
                  className="underline"
                  onClick={() => history.push(`/${i18next.language}/pages/privacy-policy`)}
                >
                  {t('HOME.COOKIES_POLICY')}{' '}
                </div> */}
                <div className="underline">
                  {this.props.home.metaData ? (
                    <a
                      href={this.props.home.metaData.social_media_urls.facebookUrl}
                      target="-blank"
                    >
                      {t('SOCIAL.FACEBOOK')}
                    </a>
                  ) : null}
                </div>
                <div className="underline">
                  {this.props.home.metaData ? (
                    <a href={this.props.home.metaData.social_media_urls.twitterUrl} target="_blank">
                      {t('SOCIAL.TWITTER')}
                    </a>
                  ) : null}
                </div>
              </div>

              <div className="font10">
                <div className="underline">
                  {this.props.home.metaData ? (
                    <a href={'https://www.instagram.com/pasajebus/'} target="_blank">
                      {t('SOCIAL.INSTAGRAM')}
                    </a>
                  ) : null}
                </div>
                <div className="underline">
                  {this.props.home.metaData ? (
                    <a href={this.props.home.metaData.social_media_urls.blogUrl} target="_blank">
                      {t('SOCIAL.BLOG_PASAJEBUS')}
                    </a>
                  ) : null}
                </div>
                <div className="underline">
                  {this.props.home.metaData ? (
                    <a href={this.props.home.metaData.social_media_urls.androidUrl} target="_blank">
                      {t('SOCIAL.PASAJEBUS_PLAYSTORE')}
                    </a>
                  ) : null}
                </div>
                <div className="underline">
                  {this.props.home.metaData ? (
                    <a href={this.props.home.metaData.social_media_urls.iosUrl} target="_blank">
                      {t('SOCIAL.PASAJEBUS_APPSTORE')}
                    </a>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    siteMap: state.siteMap,
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(DefaultPage));



// WEBPACK FOOTER //
// ./src/features/site-map/DefaultPage.js